import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

// props
interface IProps {
	percent: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CircleProgressBar',
  props: {
    percent: null
  },
  setup(__props: any) {

const props = __props as {
	percent: number;
};



// computed
const strokeOffset = computed<number>(() => {
	const circumference = 2 * Math.PI * 45
	if (!props.percent || props.percent === 0) return circumference;
	return circumference * (1 - props.percent);
});

return { __sfc: true,props, strokeOffset }
}

})